import FormResponseSet from '../model/FormResponseSet';
import m from './module';
import { createError } from '../error';

class FormResponseSetService {
  constructor(
    $q,
    FormResponseService,
    FormService,
    LogService
  ) {
    this.$q = $q;
    this.FormResponseService = FormResponseService;
    this.FormService = FormService;
    this.LogService = LogService;
  }

  create(data) {
    data = data || {};
    let formResponseDataArr = data.form_responses || [];
    const recapDefinitionId = data.recapDefinitionId || null;
    const recapResponse = data.recapResponse || null;
    const form = data.form || null;
    const formId = (form && form.id) || data.events_custom_forms_id || null;
    const eventTimezoneName = data.eventTimezoneName || null;

    let formPromise;
    if (form) {
      formPromise = this.$q.when(form);
    } else if (formId) {
      formPromise = this.FormService.getById(formId);
    } else {
      this.LogService.error("No form or form ID passed to FormResponseSetService.create(). Data:", data);
      return this.$q.reject(createError({
        error: 'MissingFormForFormResponseSet',
        message: 'Form is required for FormREsponseSet',
      }));
    }

    return formPromise
      .then(form => {
        // Create promises for each FormResponse and resolve all.
        // Swallow any errors and ignore the corresponding responses.
        return this.$q
          .all(
            formResponseDataArr
              .map(formResponseData => {
                const augmentedFormResponseData = {
                  ...formResponseData,
                  form,
                  recapDefinitionId,
                  recapResponse,
                  eventTimezoneName,
                };
                return this.FormResponseService.create(augmentedFormResponseData)
                  .catch(err => {
                    this.LogService.warn("FormResponseSetService.create() swallowing error creating FormResponse with data", augmentedFormResponseData, "error:", err);
                    return null;
                  });
              })
          )
          .then(formResponses => {
            // Filter out any null responses (swallowed errors)
            data.form_responses = formResponses.filter(formResponse => formResponse !== null);
          })
      })
      .then(() => {
        // Create form response set
        const formResponseSet = new FormResponseSet(data);

        // Link formResponseSet to all nested form responses
        formResponseSet.form_responses.forEach(formResponse => formResponse.formResponseSet = formResponseSet);
        return formResponseSet;
      });
  }
}

export default FormResponseSetService;

m.service('FormResponseSetService', FormResponseSetService);
